export const makeHumanReadable = (item: string): string => {
  if (!item) {
    return '';
  }

  return item
    .split('_')
    .reduce(
      (acc, current) =>
        acc.concat(
          current.charAt(0).toUpperCase() + current.toLowerCase().slice(1)
        ),
      []
    )
    .join(' ');
};
